import { dataHooks } from '@wix/data-hooks'

export const customizeSiteEqualSplitDataHooks = dataHooks<{
  title: {}
  backButton: {}
  cardBox: { id: string }
  linkOption: {}
  linkButton: {}
}>('customize-site-equal-split')
